export class MapMarker {
  latitude: number;
  longitude: number;
  zoom: number = 14;
  approximate: boolean = false;
}
